import { render, staticRenderFns } from "./InstitutionLayout.vue?vue&type=template&id=29574aa0&scoped=true"
import script from "./InstitutionLayout.vue?vue&type=script&lang=js"
export * from "./InstitutionLayout.vue?vue&type=script&lang=js"
import style0 from "./InstitutionLayout.vue?vue&type=style&index=0&id=29574aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29574aa0",
  null
  
)

export default component.exports